import { createSlice } from "@reduxjs/toolkit";

const paymentSlice = createSlice({
  name: "payments",
  initialState: {
    isFetching: false,
    payments: [],
    error: []
  },
  reducers: {
    statusPaymentStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusPaymentSuccess: (state, action) => {
      state.isFetching = false
      state.payments = action.payload
      state.error = []
    },
    statusPaymentFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusPaymentStart,
  statusPaymentSuccess,
  statusPaymentFailure 
} = paymentSlice.actions

export default paymentSlice.reducer